import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'Src/types/utilTypes'
import { ResponseCatalog, PartnerFullModel } from 'Models'
import { BaseItem } from 'Types/item'
import { UserShortModel } from 'Pages/auth'

type PartnerState = {
	products: ResponseCatalog<BaseItem>
	activeUsers: UserShortModel[] | null
	partnerFull: PartnerFullModel | null
}

const PartnerInitialState: PartnerState = {
	products: new ResponseCatalog<BaseItem>(),
	activeUsers: null,
	partnerFull: null,
}

export namespace PartnerNS {
	export type SendPartnerXmlToCrm = PayloadAction<number>
	export type PatchPartnerBlocking = PayloadAction<number>
	export type GetPartnerProducts = PayloadAction<number>
	export type SetPartnerProducts = PayloadAction<ResponseCatalog<BaseItem>>
	export type ClearPartnerProducts = PayloadAction
	export type GetPartnerActiveUsers = PayloadAction<number>
	export type SetPartnerActiveUsers = PayloadAction<UserShortModel[]>
	export type SetPartnerFull = PayloadAction<PartnerFullModel>
	export type GetPartnerPrivateInfo = PayloadAction<{
		id: number
		tab: string
		callback?: Callback
	}>
	export type GetPartnerPrivateInfoById = PayloadAction<{
		id: number
		query?: string
		callback?: Callback
	}>
	export type LiquidatePartner = PayloadAction<{
		id: number
		callback?: Callback
	}>
	export type RevertLiquidation = PayloadAction<{
		id: number
		callback?: Callback
	}>
}

export const partnerSlice = createSlice({
	name: 'partner',
	initialState: PartnerInitialState,
	reducers: {
		sendPartnerXmlToCrm: (state, action: PartnerNS.SendPartnerXmlToCrm) => {},
		patchPartnerBlocking: (state, action: PartnerNS.PatchPartnerBlocking) => {},
		getPartnerProducts: (state, action: PartnerNS.GetPartnerProducts) => {},
		setPartnerProducts: (state, action: PartnerNS.SetPartnerProducts) => {
			state.products = action.payload
		},
		clearPartnerProducts: (state, action: PartnerNS.ClearPartnerProducts) => {
			state.products = new ResponseCatalog()
		},
		getPartnerActiveUsers: (state, action: PartnerNS.GetPartnerActiveUsers) => {},
		setPartnerActiveUsers: (state, action: PartnerNS.SetPartnerActiveUsers) => {
			state.activeUsers = action.payload
		},
		setPartnerFull: (state, action: PartnerNS.SetPartnerFull) => {
			state.partnerFull = action.payload
		},
		getPartnerPrivateInfo: (state, action: PartnerNS.GetPartnerPrivateInfo) => {},
		getPartnerPrivateInfoById: (state, action: PartnerNS.GetPartnerPrivateInfoById) => {},
		liquidatePartner: (state, action: PartnerNS.LiquidatePartner) => {},
		revertLiquidation: (state, action: PartnerNS.RevertLiquidation) => {},
	},
})
